module.exports = __webpack_public_path__ + "static/img/i10.3f7c62e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/iosMessageSet/i10.png
// module id = 7nUY
// module chunks = 0